export default __webpack_public_path__ + "static/media/apari-arrow.26b92277.svg";